// extracted by mini-css-extract-plugin
export default {"tabsOverview":"styles_tabsOverview__QAU9z"};